import { createContext } from "react"

import { TableContextType } from "./types"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const defaultTableContext: TableContextType<any> = {
  maxDepth: 3,
  isDragDisabled: false,
  hideDefaultDragPreview: false,

  isReadonly: false,
  focusedRow: 0,

  isTableFocused: false,
  isItemSelected: () => false,
  onSelect: () => {},
  onRowFocus: () => {},
  setFocusableElement: () => {},
  focusTable: () => {},
  getRowCells: () => []
}

export const TableContext = createContext(defaultTableContext)
